/**
 * Testigo form for AtencionDialog
 */
import React from 'react';
import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { RadioGroup, RadioGroupItem } from '../ui/radio-group';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';
import { User, Wand2, Loader2 } from 'lucide-react';

const AtencionTestigoForm = ({ 
  testigoTipo, 
  testigo, 
  onTipoChange, 
  onTestigoChange,
  readOnly = false,
  onMagicClick = null,
  magicLoading = false,
  magicTooltip = ''
}) => {
  return (
    <Card className="border-[#E8E8E7]">
      <CardHeader className="pb-3">
        <CardTitle className="text-base sm:text-lg flex items-center gap-2">
          <User size={18} className="text-[#9d8272]" />
          Datos del Cliente o Testigo
          {onMagicClick && !readOnly && (
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <button
                    type="button"
                    onClick={onMagicClick}
                    disabled={magicLoading}
                    className="ml-1 p-1 rounded hover:bg-[#f5f0eb] transition-colors text-[#9d8272] hover:text-[#7a6459] disabled:opacity-50"
                    data-testid="magic-testigo-atencion-btn"
                  >
                    {magicLoading ? (
                      <Loader2 size={16} className="animate-spin" />
                    ) : (
                      <Wand2 size={16} />
                    )}
                  </button>
                </TooltipTrigger>
                <TooltipContent>
                  <p>{magicTooltip}</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          )}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {!readOnly && (
          <RadioGroup
            value={testigoTipo}
            onValueChange={onTipoChange}
            className="flex flex-wrap gap-4"
          >
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="solicitante" id="solicitante-at" />
              <Label htmlFor="solicitante-at" className="text-sm cursor-pointer">
                Igual que Solicitante
              </Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="titular" id="titular-at" />
              <Label htmlFor="titular-at" className="text-sm cursor-pointer">
                Igual que Titular
              </Label>
            </div>
          </RadioGroup>
        )}

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
          <div>
            <Label className="text-xs">Nombre *</Label>
            <Input
              value={testigo.nombre}
              onChange={(e) => onTestigoChange({...testigo, nombre: e.target.value})}
              className={`border-[#c5b8a2] text-sm ${readOnly ? 'bg-gray-50' : ''}`}
              readOnly={readOnly}
              data-testid="atencion-testigo-nombre"
            />
          </div>
          <div>
            <Label className="text-xs">DNI</Label>
            <Input
              value={testigo.dni}
              onChange={(e) => onTestigoChange({...testigo, dni: e.target.value})}
              className={`border-[#c5b8a2] text-sm ${readOnly ? 'bg-gray-50' : ''}`}
              readOnly={readOnly}
              data-testid="atencion-testigo-dni"
            />
          </div>
          <div>
            <Label className="text-xs">Teléfono</Label>
            <Input
              value={testigo.telefono}
              onChange={(e) => onTestigoChange({...testigo, telefono: e.target.value})}
              className={`border-[#c5b8a2] text-sm ${readOnly ? 'bg-gray-50' : ''}`}
              readOnly={readOnly}
              data-testid="atencion-testigo-telefono"
            />
          </div>
          <div>
            <Label className="text-xs">Correo</Label>
            <Input
              type="email"
              value={testigo.email}
              onChange={(e) => onTestigoChange({...testigo, email: e.target.value})}
              className={`border-[#c5b8a2] text-sm ${readOnly ? 'bg-gray-50' : ''}`}
              readOnly={readOnly}
              data-testid="atencion-testigo-email"
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default AtencionTestigoForm;
